import Vue from 'vue'

/**
 * Util for checking if value is number
 * @name Is Number
 * @returns {boolean} If value is a valid number
 */

const isNumber = (value) => {
  return (value || value === 0 || value === 0.0) && !Number.isNaN(Number(value))
}

Vue.filter('isNumber', isNumber)

export default isNumber
